export const maxHeight = ($interpolate) => ({
  restrict: "A",
  link(scope, element, attrs) {
    if (attrs.maxHeightDisabled==='true') {
      return;
    }
    scope.$watch(
      ($s) => $interpolate(attrs.maxHeight)($s),
      function (maxHeight) {
        if (
          maxHeight !== "false" &&
          maxHeight !== false &&
          maxHeight.match(/$\d*/)
        ) {
          element
            .css(
              "max-height",
              isFinite(maxHeight) ? maxHeight + "px" : maxHeight
            )
            .css("overflow-y", "auto");
        }
      }
    );
    if (attrs.topOn) {
      scope.$watch(attrs.topOn, function () {
        element[0].scrollTop = 0;
      });
    }
  },
});

export const maxWidth = ($interpolate) => ({
  restrict: "A",
  link(scope, element, attrs) {
    element.css("overflow-x", "auto");
    scope.$watch(
      ($s) => $interpolate(attrs.maxHeight)($s),
      function (maxWidth) {
        maxWidth !== "false" &&
          maxWidth !== false &&
          element.css(
            "max-width",
            isFinite(maxWidth) ? maxWidth + "px" : maxWidth
          );
      }
    );
    if (attrs.leftOn) {
      scope.$watch(attrs.leftOn, function () {
        element[0].scrollLeft = 0;
      });
    }
  },
});
